import { jsx as c } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { mergeClasses as p } from "../../utils/merge-classes.js";
const y = u(
  ({
    ariaDescribedBy: e,
    ariaLabel: o,
    children: i,
    className: s,
    onBlur: a,
    onClick: n,
    onFocus: l,
    role: f,
    target: r,
    url: d,
    ...m
  }, t) => {
    const b = r === "_blank" ? "noopener noreferrer" : void 0;
    return /* @__PURE__ */ c(
      "a",
      {
        "aria-describedby": e,
        "aria-label": o,
        className: p(
          "focus-visible:outline-none",
          "focus-visible:ring",
          "aria-disabled:cursor-default",
          s
        ),
        href: d,
        onBlur: a,
        onClick: n,
        onFocus: l,
        ref: t,
        rel: b,
        role: f,
        target: r,
        ...m,
        children: i
      }
    );
  }
);
export {
  y as UnstyledLink
};
